import React from 'react';
import './JoinLinkTextBox.css';
import { useEffect} from 'react';
import { ApplicationContext, ApplicationActionType } from '../context/ApplicationContext';
import { logger } from '../helpers/LoggerHelper';
import { translationsHelper } from '../helpers/TranslationsHelper';
import { TranslationKeys } from '../configuration/IConfiguration';
import { clipboardHelper } from '../helpers/ClipboardHelper';

const JoinLinkTextBox: React.FC = () => {

  const { state, dispatch } = React.useContext(ApplicationContext);
  const [latestJoinLinkWithoutDomain, setLatestJoinLinkWithoutDomain] = React.useState("");

  useEffect(() => {
    if (state.LatestJoinLink) {
      setLatestJoinLinkWithoutDomain(state.LatestJoinLink.replace("https://", ""));
    }

    if (state.LinkWasCopiedToClipboard) {
      const timerToChangeIcon = setTimeout(() => {
        dispatch({
          Action: ApplicationActionType.LinkWasCopiedToClipboard,
          Payload: false
        });
      }, 5000);
      return () => clearTimeout(timerToChangeIcon);
    }
  }, [state, dispatch, latestJoinLinkWithoutDomain]);

  const copyJoinLinkToClipboard = () => {
    dispatch({
      Action: ApplicationActionType.LinkWasCopiedToClipboard,
      Payload: true
    });
    if (state.LatestJoinLink) {
      logger.ClickedOnCopyJoinLinkToClipboard();
      clipboardHelper.copyToClipboard(state.LatestJoinLink);
    }
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.keyCode === 13) {
      copyJoinLinkToClipboard();
    }
  }

    return (

     <div>
      <div role="button" tabIndex={0} className="linkGeneratorInputBox" onClick={copyJoinLinkToClipboard} onKeyDown={onKeyDown}>
        <div className="inputContainer">
        <div className="leftIcon SkypeAssetsFont">&#xE612;</div>        
          <div className="joinLinkText">{latestJoinLinkWithoutDomain || "join.skype.com/examplelink"}</div>
          <div className={state.LinkWasCopiedToClipboard ? "rightIcon SkypeAssetsFont greenText" : "rightIcon SkypeAssetsFont grayTextColor"} > {state.LinkWasCopiedToClipboard ? "\uE412" : "\uE941" } </div>
        </div>
      </div>
      <div className={state.LinkWasCopiedToClipboard ? "linkCopiedText" : "linkCopiedText hidden"}>{translationsHelper.GetTranslation(TranslationKeys.link_copied_message)}</div>
    </div>
    );
}

export default JoinLinkTextBox;
